import { consume } from '@lit/context';
import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconPencil, iconTrashCan } from '@/components/icons';
import {
  ConfigurationContextType,
  global,
  GlobalComponentType,
  GlobalConfigurationContext,
} from '@/context';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles, buttonStyles } from '@/styles';

import './fg-configuration-detail-button';

@customElement('fg-configuration-actions')
export class FgConfigurationActions extends LitElement {
  @property({ type: Boolean })
  toggleable = false;

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: GlobalConfigurationContext })
  configurationContext!: ConfigurationContextType;

  render() {
    const { layout } = this.globalContext;
    const { configurable, deletable } = this.configurationContext;

    return html`
      <ul>
        ${configurable
          ? html`
              <li>
                <button class="button-link" @click=${this.onConfigure}>
                  ${t('actions.edit')}
                  <span>${iconPencil}</span>
                </button>
              </li>
            `
          : nothing}
        ${deletable
          ? html`
              <li>
                <button class="button-link" @click=${this.onDelete}>
                  ${t('actions.delete')}
                  <span>${iconTrashCan}</span>
                </button>
              </li>
            `
          : nothing}
        ${this.toggleable && layout === 'retail'
          ? html`
              <li class="details">
                <fg-configuration-detail-button
                  part=${layout}
                ></fg-configuration-detail-button>
              </li>
            `
          : nothing}
      </ul>
    `;
  }

  onConfigure() {
    this.dispatchEvent(new Event('configure', { composed: true }));
  }

  onDelete() {
    this.dispatchEvent(new Event('delete', { composed: true }));
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      ul,
      button {
        display: flex;
        align-items: center;
      }

      ul {
        gap: 24px;
        justify-content: space-between;
      }

      button {
        display: flex;
        gap: 5px;
        align-items: center;
      }

      button span {
        display: flex;
      }

      li.details button:not(.active) span {
        transform: rotate(-180deg);
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        ul {
          justify-content: flex-end;
        }
      }
    `,
  ];
}
